export class Link {
    Type: string;
    LinkText: string;

    constructor(data) {
        this.Type = data.LinkType;
        this.LinkText = data.LinkText;
    }
}
